module.exports = __webpack_public_path__ + "static/media/ec.pictogram.5df651cd.svg";